export enum ActivityActionType {
  PinToTop = 1,
  Unpin = 2,
  Edit = 3,
  ReplyAll = 4,
  Delete = 5,
}
